import React, { useEffect, useState } from "react";
import { Skeleton, CircularProgress } from "@mui/material";
import {
  Container,
  Grid,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  Chip,
  Card,
  CardMedia,
  useMediaQuery,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Breadcrumbs,
  Link as MuiLink,
  IconButton,
  CardContent,
  TextField,
  Stack,
  Pagination,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { styled } from "@mui/material/styles";

// Icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "@mui/icons-material/Home";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AreaGroupDisplay from "../AreaGroupComponent";
import { FaLocationDot } from "react-icons/fa6";
import EmailIcon from "@mui/icons-material/Email";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PersonIcon from "@mui/icons-material/Person";
import NoteIcon from "@mui/icons-material/Note";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSearchParams } from "react-router-dom";
import { useFilter } from "@context/filterContext";
import { toast } from "react-toastify";
import SEO from "../../../utils/SeoComponent";
import { ROUTES } from "../../../constants/routes";

const ImageContainer = styled(Box)({
  position: "relative",
  overflow: "hidden",
  height: 220,
});

const PriceTag = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 20,
  left: 0,
  backgroundColor: "#C10E14",
  color: "white",
  padding: "6px 15px",
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  fontWeight: "bold",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  zIndex: 2,
}));

const ContactButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  padding: "8px 16px",
  fontWeight: "bold",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    boxShadow: theme.shadows[2],
  },
}));

const AreaDetailPage = () => {
  const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;
  const navigate = useNavigate();
  const { title } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [areaData, setAreaData] = useState(null);
  const [projects, setProjects] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true); // Initially loading
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
  });
  const itemsPerPage = 2;

  useEffect(() => {
    const fetchAreaData = async () => {
      try {
        const response = await axios.get(
          `${DESCO_API_BASE}/developers/index/${title}`
        );
        setAreaData(response?.data?.data);
      } catch (error) {
        console.error("Error fetching area data:", error);
      }
    };

    if (title) {
      fetchAreaData();
    }
  }, [title]);

  let areaDetailData = areaData?.[0];

  const fetchPropertiesByDeveloper = async () => {
    try {
      const response = await axios.post(
        "https://panel.estaty.app/api/v1/filter",
        {
          developer_company_id: areaDetailData?.developer_id, // Replace with actual developer ID(s)
          currency: "AED",
          area_unit: "square meters",
        },
        {
          headers: {
            "App-key": "3dc9efc076a8d36602ef445c924fa7cf",
          },
        }
      );
      setProjects(response.data.properties);
      // console.log("Filtered Properties:", response.data.properties);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };  



  console.log("areaData",areaData)

  useEffect(() => {
    fetchPropertiesByDeveloper();
  }, []);

  let developerProjects = [];
  developerProjects = [
    ...(areaData?.[0].properties || []),
    ...(projects || []),
  ];

  // Calculate pagination
  const pageCount = Math.ceil((developerProjects?.length || 0) / itemsPerPage);

  // console.log("pageCount",pageCount)
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedAreas = Array.isArray(developerProjects)
    ? developerProjects.slice(startIndex, startIndex + itemsPerPage)
    : [];

  // console.log("paginatedAreas",paginatedAreas)
  // Handle page change
  const handlePageChange = (_, newPage) => {
    setCurrentPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === areaDetailData?.gallery_images.length - 1
        ? 0
        : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0
        ? areaDetailData?.gallery_images.length - 1
        : prevIndex - 1
    );
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append("first_name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("message", formData.note);

    try {
      const res = await axios.post(
        `${DESCO_API_BASE}/contact_us/contact_us`,
        formDataToSend
      );
      toast.success("Submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        note: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong!");
    }
  }; 

  const metaTitle = "test"
  const metaDescription = "testing description"


  return (
    <>
      <SEO slug={"developerdetailpage"}  title={metaTitle} description={metaDescription}/>
      <Container
        maxWidth="lg"
        sx={{
          my: { xs: 2, sm: 3, md: 4 },
          paddingTop: {
            xs: "40px", // below 600px
            sm: "80px", // 600px and above
            md: "100px", // 900px and above
            lg: "120px", // 1200px and above
          },
          px: { xs: 2, sm: 3, md: 4 }, // Adjusted padding for mobile
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Breadcrumbs - Hide on mobile for space */}
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 3 }}
          >
            <MuiLink component={Link} to="/" color="inherit">
              Home
            </MuiLink>
            <MuiLink component={Link} to="/developers" color="inherit">
              Developers
            </MuiLink>
            <Typography color="text.primary">
              {areaDetailData?.title || "Developer Details"}
            </Typography>
          </Breadcrumbs>
        </Box>

        {/* Mobile Title (only visible on xs screens) */}
        <Box sx={{ display: { xs: "block", sm: "none" }, mb: 2 }}>
          <Typography variant="h5" component="h1" fontWeight="bold">
            {areaDetailData?.title || "Area Details"}
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 2, sm: 4 }}>
          <Grid item xs={12}>
            <AreaGroupDisplay developerData={areaDetailData} />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={{ xs: 2, md: 4 }}>
              {/* Properties column - takes full width on mobile */}

              <Grid item xs={12} md={8}>
                {isLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%", // Adjust or set a fixed height if needed
                      minHeight: 200, // Optional: ensures enough space to visibly center
                    }}
                  >
                    <Typography color="black">Loading projects...</Typography>
                  </Box>
                ) : (
                  <>
                    {" "}
                    {paginatedAreas.map((property) => (
                      <PropertyCard
                        key={property?.id}
                        property={property}
                        isLoading={isLoading}
                      />
                    ))}
                    {pageCount > 1 && (
                      <Stack spacing={2} sx={{ mt: 6, alignItems: "center" }}>
                        <Pagination
                          count={pageCount}
                          page={currentPage}
                          onChange={handlePageChange}
                          shape="rounded"
                          sx={{
                            "& .MuiPaginationItem-root": {
                              fontWeight: 600,
                              "&.Mui-selected": {
                                backgroundColor: "#C10E14",
                                color: "white",
                              },
                            },
                          }}
                        />
                      </Stack>
                    )}{" "}
                  </>
                )}
              </Grid>

              {/* Contact form column - takes full width on mobile */}
              <Grid item xs={12} md={4}>
                <ContactForm
                  formData={formData}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  logo={areaDetailData?.image}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AreaDetailPage;

const PropertyCard = ({ property }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  console.log("property?.city_id", property?.city_id);

  const onNavigate = () => {
    if (property?.city_id) {
      // Navigate to project detail page using centralized route
      navigate(ROUTES.PROJECT_DETAIL(property.id));
    } else {
      // Navigate to property detail page using centralized route
      navigate(ROUTES.PROPERTIES(property?.slug), {
        state: { page: property?.category },
      });
    }
  };

  return (
    <Card
      sx={{
        mb: { xs: 3, sm: 4 },
        borderRadius: 2,
        overflow: "hidden",
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: { xs: "none", sm: "translateY(-5px)" }, // Disable transform on mobile
          boxShadow: 8,
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* Tag */}
        {property?.tag && (
          <Box
            sx={{
              position: "absolute",
              top: 20,
              left: 0,
              bgcolor: "black",
              color: "white",
              py: 0.5,
              px: 2,
              zIndex: 1,
              fontSize: { xs: "0.75rem", sm: "0.875rem" }, // Smaller font on mobile
            }}
          >
            {property?.tag}
          </Box>
        )}

        {/* Payment Plan */}
        {property?.paymentPlan && (
          <Box
            sx={{
              position: "absolute",
              top: 20,
              left: 0,
              bgcolor: "#C10E14",
              color: "white",
              py: 0.5,
              px: 2,
              zIndex: 1,
              fontSize: { xs: "0.75rem", sm: "0.875rem" }, // Smaller font on mobile
            }}
          >
            {property?.paymentPlan}
          </Box>
        )}

        {/* Property Image */}
        <CardMedia
          component="img"
          height={isMobile ? "200" : "300"} // Smaller height on mobile
          image={property?.thumbnail || property?.cover}
          alt={property?.title}
          sx={{
            transition: "transform 0.5s",
            "&:hover": {
              transform: { xs: "none", sm: "scale(1.05)" }, // Disable transform on mobile
            },
          }}
        />
      </Box>

      <CardContent
        sx={{
          px: { xs: 2, sm: 3 },
          pt: { xs: 2, sm: 3 },
          pb: { xs: 3, sm: 4 },
        }}
      >
        {/* Logo/Letter */}
        <Box sx={{ display: "flex", mb: 2, alignItems: "center" }}>
          <Box>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              component="h2"
              sx={{ fontWeight: 600 }}
            >
              {property?.title}
            </Typography>
            <Typography
              variant={isMobile ? "body2" : "subtitle1"}
              color="text.secondary"
            >
              {property?.type}
            </Typography>
          </Box>
        </Box>

        {/* Price */}
        <Typography
          variant={isMobile ? "h5" : "h4"}
          component="h3"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          {property?.price || property?.low_price} AED
        </Typography>

        {/* Location */}
        <Box
          sx={{ display: "flex", alignItems: "center", mb: { xs: 2, sm: 3 } }}
        >
          <LocationOnIcon
            sx={{
              color: "#C10E14",
              mr: 1,
              fontSize: isMobile ? "1.2rem" : "1.5rem",
            }}
          />
          <Typography variant={isMobile ? "body2" : "body1"}>
            {property?.location || property?.district?.name}
          </Typography>
        </Box>

        {/* Action buttons - Stack on mobile if there's not enough space */}
        <Box
          sx={{
            display: "flex",
            gap: { xs: 1, sm: 2 },
            flexDirection: { xs: isMobile ? "column" : "row", sm: "row" },
          }}
        >
          <Button
            variant="contained"
            startIcon={<EmailIcon />}
            sx={{
              bgcolor: "black",
              flex: 1,
              borderRadius: 1,
              py: { xs: 1, sm: 1.2 }, // Taller on desktop
              fontSize: { xs: "0.8rem", sm: "0.875rem" }, // Smaller font on mobile
              "&:hover": { bgcolor: "#333" },
            }}
            onClick={() => navigate(ROUTES.CONTACT_US)}
          >
            Message
          </Button>
          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              bgcolor: "#C10E14",
              flex: 1,
              borderRadius: 1,
              py: { xs: 1, sm: 1.2 }, // Taller on desktop
              fontSize: { xs: "0.8rem", sm: "0.875rem" }, // Smaller font on mobile
              "&:hover": { bgcolor: "#9c0c11" },
            }}
            onClick={onNavigate}
          >
            Discover more
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

// Contact Form Component
const ContactForm = ({ formData, handleChange, handleSubmit, logo }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 }, // Less padding on mobile
        borderRadius: 2,
        mb: { xs: 3, sm: 0 }, // Add margin bottom on mobile
        backgroundColor: "#f9fafb",
      }}
    >
      {/* <Box sx={{ textAlign: "center", mb: { xs: 2, sm: 3 } }}>
        <img
          src={logo}
          alt="developer Logo"
          style={{
            maxWidth: "100%",
            height: "auto",
            width: isMobile ? "120px" : "150px" // Smaller on mobile
          }}
        />
      </Box> */}

      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
          <TextField
            fullWidth
            placeholder="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <PersonIcon
                  sx={{
                    color: "action.active",
                    mr: 1,
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                />
              ),
            }}
            variant="outlined"
            size={isMobile ? "small" : "medium"} // Smaller input on mobile
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#C10E14", // 🔴 red outline when focused
                },
              },
            }}
          />
        </Box>

        <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
          <TextField
            fullWidth
            placeholder="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <EmailIcon
                  sx={{
                    color: "action.active",
                    mr: 1,
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                />
              ),
            }}
            variant="outlined"
            size={isMobile ? "small" : "medium"} // Smaller input on mobile
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#C10E14", // 🔴 red outline when focused
                },
              },
            }}
          />
        </Box>

        <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
          <TextField
            fullWidth
            placeholder="000-000-000"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <PhoneIcon
                  sx={{
                    color: "action.active",
                    mr: 1,
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                />
              ),
            }}
            variant="outlined"
            size={isMobile ? "small" : "medium"} // Smaller input on mobile
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#C10E14", // 🔴 red outline when focused
                },
              },
            }}
          />
        </Box>

        <Box sx={{ mb: { xs: 2, sm: 3 } }}>
          <TextField
            fullWidth
            placeholder="Note"
            name="note"
            value={formData.note}
            onChange={handleChange}
            multiline
            rows={isMobile ? 3 : 4} // Fewer rows on mobile
            InputProps={{
              startAdornment: (
                <NoteIcon
                  sx={{
                    color: "action.active",
                    mr: 1,
                    mt: 0.5,
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                />
              ),
            }}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#C10E14", // 🔴 red outline when focused
                },
              },
            }}
          />
        </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<EmailIcon />}
          sx={{
            bgcolor: "#C10E14",
            py: { xs: 1, sm: 1.5 }, // Slightly smaller height on mobile
            fontSize: { xs: "0.85rem", sm: "1rem" }, // Smaller font on mobile
            "&:hover": { bgcolor: "#9c0c11" },
          }}
        >
          Get Free Advice Now
        </Button>
      </form>
    </Paper>
  );
};
